import React, { ChangeEvent } from "react";
import { Trash2 } from "lucide-react";
import { Key } from "./types";

interface KeyTableProps {
  keys: Key[];
  handleRemoveKeyx: (id: number) => void;
  handleKeyChange: (index: number, field: keyof Key, value: number | string) => void;
  highlightedIndex?: number | null;
}

const KeyTable: React.FC<KeyTableProps> = ({ keys, handleRemoveKeyx, handleKeyChange, highlightedIndex = null }) => {
  return (
    <div className="key-table">
      {keys.map((el, index) => (
        <div key={index} className={`key-table-row${highlightedIndex === index ? " is-highlighted" : ""}`}>
          {/* Kosz zamiast czerwonego X - krzyżyk w matrycy poniżej oznacza uprawnienie */}
          <span
            role="button"
            className="table-trash"
            title="Schlüssel löschen"
            aria-label="Schlüssel löschen"
            onClick={() => handleRemoveKeyx(Number(el.id))}
          >
            <Trash2 size={18} strokeWidth={2} />
          </span>
          <input
            type="number"
            className="inputCenter"
            placeholder=""
            value={el.amount}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleKeyChange(
                index,
                "amount",
                parseInt(e.target.value, 10)
              )
            }
          />

          <input
            type="text"
            value={el.keyName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleKeyChange(index, "keyName", e.target.value)
            }
          />

          {/* Numer klucza tuż nad jego kolumną w matrycy - ułatwia trafienie w kolumnę */}
          <span className="key-table-index" aria-hidden="true">{index + 1}</span>
        </div>
      ))}
    </div>
  );
};

export default KeyTable;
